import styled from 'styled-components';

export const Body = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
`;
